export class Transaction {
  id = -1;
  amount_cents = -1;
  refundable_amount_cents = 0;
  invoice_id = -1;
  transaction_time = "";
  transaction_type: TransactionType = TransactionType.CARD;
  entry_method?: EntryMethod = EntryMethod.KEYED;
  processor_name?: ProcessorName = undefined;
  ach_account_type?: AchAccountType = undefined;
  payer_name = "";
  ach_last4?: string = undefined;
  card_last4?: string = undefined;
  card_brand?: string = undefined;
  check_number?: string = undefined;
  reconciled = false;
  voided = false;
  status: TransactionStatus = TransactionStatus.PENDING;
  notes = "";
  reference_id = -1;
  receiver?: {
    id: number;
    type: string;
    email: string;
    full_name: string;
  } = undefined;
  links?: {
    payment_refund: string;
    invoice_refund: string;
  } = undefined;

  constructor(params: Partial<Transaction> = {}) {
    Object.assign(this, params);
  }
}

export enum TransactionType {
  CARD = "card",
  ACH = "ach",
  CASH = "cash",
  CHECK = "check",
  EXTERNAL = "external",
  EXTERNAL_FINANCING = "external_financing",
  UNKNOWN_TYPE = "unknown_type"
}

export enum EntryMethod {
  KEYED = "keyed",
  READER = "reader",
  SAVED = "saved",
  SWIPED = "swiped",
  DIPPED = "dipped",
  TAPPED = "tapped"
}

export enum ProcessorName {
  GPI = "gpi",
  STAX = "stax"
}

export enum AchAccountType {
  CHECKING = "checking",
  SAVINGS = "savings"
}

export enum TransactionStatus {
  SUCCEEDED = "succeeded",
  FAILED = "failed",
  VOIDED = "voided",
  PENDING = "pending",
  ATTEMPTED = "attempted"
}
